import React, {useState, useEffect, useMemo} from "react";
import BodyMain from "../../components/util/BodyMain";
import { 
    Grid,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    MenuItem,
    Box,
    Typography,
    InputAdornment,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload'

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'


import { enqueueSnackbar } from 'notistack';

import { constants } from '../../util'
import { getCountries } from '../../services/CatalogService';
import { showWaiting } from "../../store/slices/configSlice";
import { setIsFullProfile, setProfilePhoto } from "../../store/slices/userSlice";
import { getProfile, saveProfile, uploadProfilePhoto } from "../../services/profileService";


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '100%',
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: '100%', // Cambiado de 1 a 100%
    opacity: 0, // Usamos opacidad 0 en lugar de tamaño mínimo
});




const Profile = () => {
    //TRANSLATION
    const [t, i18n] = useTranslation("global");
    const {language, openSignup, deviceType} = useSelector(state => state.configuration);

    const sch = (yup) => yup.object({
            nameArtist: yup.string().required().min(3).max(40),
            company: yup.string().required().min(3).max(40),
            originCountry: yup.string().required(),
            phone: yup.string().matches(/^[0-9]+$/, t("validations.onlyNumbers")).required().min(10).max(13),
            urlTiktok: yup.string().url().required().max(500),
            urlYoutube: yup.string().url().max(500),
            urlInstagram: yup.string().url().required().max(500),
            urlFacebook: yup.string().url().max(500),
            urlSpotify: yup.string().url().required().max(500),
            urlApple: yup.string().url().required().max(500),
            biography: yup.string().max(7500),
        });

    const schema = useYupSchema(sch);
    
    
    // useEffect(() => {
    //     yup = configureYup(language);
    // }, [language]);


    const {profilePhoto} = useSelector(state => state.userLogged);
    const dispatch = useDispatch();
    const [countries, setCountries] = useState([]);
    // const [profilePhoto, setProfilePhoto] = useState('');

    
    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            nameArtist: ' ',
            company: ' ',
            originCountry: '',
            phone: ' ',
            urlTiktok: ' ',
            urlSpotify: ' ',
            urlApple: ' ',
            biography: ' '
        }
    });


    const uploadFile = (event) => {
        dispatch(showWaiting(true));
        const files = event.target.files;
        if (files.length > 0){
            uploadProfilePhoto(files[0])
                .then( (rsp) => {
                    setTimeout(() => {
                        if (rsp.code==='00')
                            dispatch(setProfilePhoto(rsp.metadata?.urlImage));
                        else
                            enqueueSnackbar(rsp.message, { variant: 'error', persist: false });

                        dispatch(showWaiting(false));
                    }, 1000);
                });
        }
    }

    
    const onSubmit = (data) => {
        dispatch(showWaiting(true));
        
        saveProfile(
            data.nameArtist,
            data.company,
            data.originCountry,
            data.phone,
            data.urlTiktok,
            data.urlYoutube,
            data.urlInstagram,
            data.urlFacebook,
            data.urlSpotify,
            data.urlApple,
            data.biography
        ).then(
            (rsp) => {
                setTimeout(() => {
                    dispatch(setIsFullProfile(true));
                    dispatch(showWaiting(false));
                    enqueueSnackbar(rsp.message, { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                }, 1000);
            }
        )
    }

    useEffect(() => {
        dispatch(showWaiting(true));

        getCountries()
            .then(rsp => {
                if (rsp.code === '00')
                    setCountries(rsp.metadata.countries);
                else
                {
                    setCountries([]);
                    enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                }
            });
        
        getProfile()
            .then((rsp)=>{
                setTimeout(() => {
                    reset(rsp.metadata);
                    dispatch(setProfilePhoto(rsp.metadata?.profilePhoto));
                    dispatch(showWaiting(false));
                    
                    if (rsp.code!=='00')
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                }, 1000);
            })
    }, []);


    return(
        <>
            <BodyMain>
                <Grid container size={12} sx={{marginTop:'20px'}}>
                    <Grid item 
                        size={{
                            sxs:12,
                            xs:12,
                            sm:12,
                            md:3,
                            lg:3,
                            xl:3,
                        }} 
                        sx={{textAlign:'center', paddingTop:'20px'}}
                    >
                        <img src={profilePhoto}
                            style={{ width: (deviceType==='minicell' || deviceType==='cell' || deviceType==='laptop' ? '60%' : '40%')}} />
                        <br />
                        <Button 
                            component="label" 
                            variant="text" 
                            startIcon={<CloudUploadIcon />}
                            sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative' }}
                        >
                            {t("profile.btnImageChange")}
                            <VisuallyHiddenInput
                                type="file"
                                onChange={(event) => uploadFile(event)}
                                multiple={false}
                            />
                        </Button>
                    </Grid>
                    <Grid item 
                        size={{
                            sxs:12,
                            xs:12,
                            sm:12,
                            md:9,
                            lg:9,
                            xl:9,
                        }} 
                        sx={{
                            padding:0,
                            paddingLeft:'30px',
                            paddingRight:'30px'
                        }}
                    >
                        <h2>{t("profile.title1")}</h2>
                        <form onSubmit={handleSubmit(onSubmit)}
                            style={{
                                width:'100%',
                                height:'100%',
                                display:'flex',
                                flexDirection:'column',
                            }}
                        >
                            <TextField id="txtName" label={t("signUp.name")} variant="outlined" margin="normal" autoFocus fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('nameArtist')}
                                error={!!errors.nameArtist}
                                helperText={errors.nameArtist?.message}
                            />
                            <TextField id="txtCompany" label={t("signUp.company")} variant="outlined" margin="dense" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}}
                                defaultValue={getValues('company') || ''}
                                {...register('company')}
                                error={!!errors.company}
                                helperText={errors.company?.message}
                            />
                            <Controller
                                name="originCountry"
                                control={control}
                                render={({ field }) => (
                                <FormControl fullWidth error={!!errors.originCountry}>
                                    <InputLabel id="country-label">{t("signUp.country")}</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="country-label"
                                        label={t("signUp.country")}
                                        sx={{ width: '100%', marginBottom: '15px' }}
                                    >
                                        {
                                            countries?.map(e => (
                                                <MenuItem value={e.id}>
                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        <img
                                                            src={`/assets/img/flags/${e.flagKey}.svg`}
                                                            alt={e.name}
                                                            style={{ width:'18px', height:'13px' }}
                                                        />
                                                        <Typography>{e.name}</Typography>
                                                    </Box>
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                    <FormHelperText>
                                        {errors.originCountry?.message}
                                    </FormHelperText>
                                </FormControl>
                                )}
                            />
                            <TextField id="txtPhone" label={t("signUp.phone")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('phone')}
                                error={!!errors.phone}
                                helperText={errors.phone?.message}
                            />

                            <h4 style={{color:'gray', marginBottom:'20px'}}>{t("profile.title2")}</h4>
                            
                            
                            
                            <TextField id="txtSpotify" label={t("signUp.spotify")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/spotity-c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlSpotify')}
                                error={!!errors.urlSpotify}
                                helperText={errors.urlSpotify?.message}
                            />
                            <TextField id="txtApple" label={t("signUp.apple")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/apple-c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlApple')}
                                error={!!errors.urlApple}
                                helperText={errors.urlApple?.message}
                            />
                            <TextField id="txtTiktok" label={t("signUp.tiktok")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/tiktok-c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlTiktok')}
                                error={!!errors.urlTiktok}
                                helperText={errors.urlTiktok?.message}
                            />
                            <TextField id="txtInstagram" label={t("signUp.instagram")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/instagram_color.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlInstagram')}
                                error={!!errors.urlInstagram}
                                helperText={errors.urlInstagram?.message}
                            />
                            <TextField id="txtYoutube" label={t("signUp.youtube")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/youtube.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlYoutube')}
                                error={!!errors.urlYoutube}
                                helperText={errors.urlYoutube?.message}
                            />
                            <TextField id="txtFacebook" label={t("signUp.facebook")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img
                                            src="/assets/img/logo/facebook_c.png"
                                            alt="icon"
                                            style={{ width: 25, height: 25 }}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                {...register('urlFacebook')}
                                error={!!errors.urlFacebook}
                                helperText={errors.urlFacebook?.message}
                            />

                            <h4 style={{color:'gray', marginBottom:'20px'}}>{t("profile.title3")}</h4>
                            
                            <TextField id="txtBiography" multiline fullWidth minRows={10} maxRows={17}
                                label={t("profile.txtBiography")} variant="outlined" margin="normal"  
                                sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                {...register('biography')}
                                error={!!errors.biography}
                                helperText={errors.biography?.message}
                            />

                            <Button type='submit' variant="text" 
                                sx={{ ...constants.styles.mainButton, marginTop:'50px', marginBottom:'30px', 
                                width: (deviceType==='minicell' || deviceType==='cell' || deviceType==='tablet' ? '100%' : '30%') }}>{t("profile.btnSave")}</Button>
                        </form>
                    </Grid>
                </Grid>
            </BodyMain>
        </>
    );
}

export default Profile;